import React from 'react';
import useScrollEffects from './hooks/useScrollEffects';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Narrative from './components/sections/Narrative';
import Capabilities from './components/sections/Capabilities';
import Process from './components/sections/Process';
import Contact from './components/sections/Contact';

export default function BrivaWebsite() {
  useScrollEffects();

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Narrative />
        <Capabilities />
        <Process />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
